import ImagesIconsHelpAuthSvg from '@/public/images/icons/help/auth.svg';
import ImagesIconsHelpBuyingSvg from '@/public/images/icons/help/buying.svg';
import ImagesIconsHelpGuidelinesSvg from '@/public/images/icons/help/guidelines.svg';
import ImagesIconsHelpMyAccountSvg from '@/public/images/icons/help/myAccount.svg';
import ImagesIconsHelpPaymentsSvg from '@/public/images/icons/help/payments.svg';
import ImagesIconsHelpPolicySvg from '@/public/images/icons/help/policy.svg';
import ImagesIconsHelpSellingSvg from '@/public/images/icons/help/selling.svg';
import ImagesIconsHelpShippingSvg from '@/public/images/icons/help/shipping.svg';

export {
  ImagesIconsHelpAuthSvg,
  ImagesIconsHelpBuyingSvg,
  ImagesIconsHelpGuidelinesSvg,
  ImagesIconsHelpMyAccountSvg,
  ImagesIconsHelpPaymentsSvg,
  ImagesIconsHelpPolicySvg,
  ImagesIconsHelpSellingSvg,
  ImagesIconsHelpShippingSvg,
};
